import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationContextDatasourceService } from '../../../backend/datasource/authentication-context-datasource.service';
import { ThemeHandlerService } from '../../service/theme-handler.service';
import { Theme } from '../../../backend/model/theme.model';
import { IDCardModule } from '@inera/ids-angular/components/card';
import { NgTemplateOutlet } from '@angular/common';
import { ThemeType } from '../../../backend/model/theme-type';
import { IDLinkModule } from '@inera/ids-angular/components/link';

@Component({
  selector: 'idp-mtls-rotation-limit',
  standalone: true,
  imports: [IDCardModule, IDLinkModule, NgTemplateOutlet],
  templateUrl: './mtls-rotation-limit.component.html',
  styleUrls: ['./mtls-rotation-limit.component.scss']
})
export class MtlsRotationLimitComponent implements OnInit {
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);
  private themeHandler = inject(ThemeHandlerService);

  private readonly X509_ROUTE = 'x509';

  public theme: Theme | null = null;
  public themeType = ThemeType;

  ngOnInit(): void {
    this.themeHandler.getTheme().subscribe(theme => {
      this.theme = theme?.value?.value ?? null;
    });
  }
  private getRedirect(path: string): string {
    let url = `${window.location.origin}/${this.authenticationContextDatasource.getIdp()}/${this.X509_ROUTE}/${path}`;

    const sessionId = this.authenticationContextDatasource.getSessionId();

    if (typeof sessionId === 'string' && sessionId.length > 0) {
      url += `?id=${sessionId}`;
    }

    return url;
  }
  public cancel(): void {
    window.location.href = this.getRedirect('cancel');
  }

  public getMethodTypeInstructionsText(): string {
    if (this.authenticationContextDatasource.getIsSignature()) {
      return 'signeringsförsök';
    } else {
      return 'inloggningsförsök';
    }
  }

  public getMethodTypeText(): string {
    if (this.authenticationContextDatasource.getIsSignature()) {
      return 'underskriften';
    } else {
      return 'inloggningen';
    }
  }
}
